import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { logTermAction } from './useTermsOfUseLogs';

interface CreateTermParams {
  content: string;
  createdByUserId: string;
  createdByUserName: string;
}

export const useCreateTerm = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ content, createdByUserId, createdByUserName }: CreateTermParams) => {
      // Inserir o novo termo (pending_activation = true por padrão)
      const { data, error: insertError } = await supabase
        .from('terms_of_use')
        .insert({
          content,
          created_by_user_id: createdByUserId,
          created_by_user_name: createdByUserName,
          pending_activation: true
        })
        .select('id')
        .single();
      
      if (insertError) throw insertError;
      
      // Registrar log de criação
      await logTermAction({
        termId: data.id,
        action: 'create',
        userId: createdByUserId,
        userName: createdByUserName
      });
      
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['terms-of-use'] });
      queryClient.invalidateQueries({ queryKey: ['term-acceptance'] });
      toast.success('Novo termo criado com sucesso');
    },
    onError: (error) => {
      console.error('Erro ao criar termo:', error);
      toast.error('Erro ao criar novo termo');
    }
  });
};
